import { render, staticRenderFns } from "./listServices.vue?vue&type=template&id=e2ca034e&scoped=true"
import script from "./listServices.vue?vue&type=script&lang=js"
export * from "./listServices.vue?vue&type=script&lang=js"
import style0 from "./listServices.vue?vue&type=style&index=0&id=e2ca034e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ca034e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VSkeletonLoader,VTextField})
